import { render, staticRenderFns } from "./add-title-speaker.vue?vue&type=template&id=224f2936&scoped=true"
import script from "./add-title-speaker.vue?vue&type=script&lang=js"
export * from "./add-title-speaker.vue?vue&type=script&lang=js"
import style0 from "./add-title-speaker.vue?vue&type=style&index=0&id=224f2936&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f2936",
  null
  
)

export default component.exports